module.exports = __webpack_public_path__ + "img/5 - 4 - 1.40cf1eb7.jpg";